import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import BlueNormalButton from '../customButtons/BlueNormalButton';
import PrimarySmallBlueButton from '../customButtons/PrimarySmallBlueButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function NoTestTypePurchaseScreen({text, subText ,maxWidth, buttonName, topImage, redirectionLink, showHeading , headingIcon,onClick}) {
      const navigate = useNavigate();

      const handleNavigation =()=>{
       console.log("redirectionLink",redirectionLink)
        navigate(redirectionLink)
      }
  return (
 <Box
      sx={{
        maxWidth: maxWidth? maxWidth : 800,
        mx: "auto",
pb:3,
    //    p:3,
        textAlign: "center",
        borderRadius: "16px",
        backgroundColor: "#fff",
       boxShadow:  "0px 0px 4px rgba(0, 0, 0, 0.1)",
        position: "relative",
          border: "1px solid #EAE3E3",
      }}
    >
      <Box
        position="absolute"
        bottom={0}
        left={0}
        sx={{
          width: "60px",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Performance/Ellipse 9322.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Box
        position="absolute"
        top={0}
        right={0}
        sx={{
          width: "90px",
          borderBottomRightRadius: "15px",
          borderBottomLeftRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Performance/Ellipse 9323.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Grid container  
      
      >
 <Grid
                item
                xs={12}
                display="flex"
                alignItems="center"
                gap={1}
                pl={3}
                pt={3}
              
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={25}>
                    <img src={headingIcon}/>
                  </Box>
                  <Typography
                    fontFamily="Inter"
                    fontWeight={600}
                    color="#572575"
                    fontSize="20px"
                  >
                 {showHeading}
                  </Typography>{" "}
                </Box>
                </Grid>
        
        <Grid item xs={12} >

<Grid container spacing={2} sx={{  
         px: { xs: 2, sm: 7, md: 15 },}}>
        <Grid item xs={12}>
          <Box
            sx={{
              width: 180,
              height: 180,
              mx: "auto",
             mt:{xs:0, md:-4}
            }}
          >
           {topImage}
          </Box>
        </Grid>

        {/* Title */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="22px"
            color="#343538"
            sx={{
              fontWeight: 600,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: "1.4",
            }}
          >
            {text}
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item xs={12}  zIndex={9999}>
          {" "}
          <Typography
            fontSize="16px"
            color="#3F424C"
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: 1.5,
             
            }}
          >
            {subText}
          </Typography>
        </Grid>

        {/* Button */}
        <Grid item xs={12} mt={1}>
          {" "}
       <PrimarySmallBlueButton buttonTitle={buttonName} endIcon={<ArrowForwardIcon/>} onClick={onClick}/>
        </Grid>
</Grid>
        </Grid>
      </Grid>
    </Box>
  )
}
